/**
 * src/lib/motivosLimite.ts
 * =============================================================================
 * Qué códigos de error son un TOPE y no un fallo.
 *
 * Vive aquí y no junto al modal porque mezclar componentes con funciones
 * sueltas en el mismo fichero rompe la recarga en caliente de Vite: al editar
 * el modal se recargaría la página entera en vez de solo el componente.
 *
 * La distinción importa más de lo que parece. Un fallo se reintenta; un tope,
 * no. Tratarlos igual es lo que hacía que a alguien sin espacio le saliera
 * "algo falló, inténtalo de nuevo" — invitándole a repetir algo que no iba a
 * funcionar nunca.
 * =============================================================================
 */

/** Códigos que el producto sabe explicar como un límite alcanzado. */
export type MotivoLimite = 'free_tier_paused' | 'storage_quota_exceeded' | 'signup_paused'

export function esMotivoDeLimite(codigo: string | null | undefined): codigo is MotivoLimite {
  return (
    codigo === 'free_tier_paused' ||
    codigo === 'storage_quota_exceeded' ||
    codigo === 'signup_paused'
  )
}
